import React from 'react';
import { FadeIn } from './FadeIn';
export function ProductReveal() {
  return <section className="py-16 px-4 bg-cream" data-id="element-398">
      <div className="max-w-3xl mx-auto" data-id="element-399">
        <FadeIn data-id="element-400">
          <div className="bg-white rounded-3xl p-8 md:p-12 border-2 border-green-lime shadow-soft text-center relative overflow-hidden" data-id="element-401">
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-green-deep via-green-lime to-green-mint" data-id="element-402"></div>

            <div className="inline-flex items-center justify-center w-16 h-16 bg-green-mint/20 rounded-full mb-6" data-id="element-403">
              <span className="text-3xl" data-id="element-404">🛡️</span>
            </div>

            <h2 className="font-heading font-bold text-3xl md:text-5xl text-green-deep mb-4" data-id="element-405">
              INMUNIDAD TOTAL
            </h2>

            <p className="text-lg md:text-xl font-medium text-text-main mb-8 max-w-xl mx-auto" data-id="element-406">
              El Protocolo Avanzado de Salud Intestinal para Blindar las
              Defensas de tu Peque <br className="hidden md:block" data-id="element-407" />
              <span className="text-green-deep" data-id="element-408">— Sin Medicamentos —</span>
            </p>

            <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-sm md:text-base font-medium text-text-main/80" data-id="element-409">
              <div className="flex items-center gap-2 bg-cream px-4 py-2 rounded-full" data-id="element-410">
                <span data-id="element-411">📚</span> 9 Capítulos
              </div>
              <div className="flex items-center gap-2 bg-cream px-4 py-2 rounded-full" data-id="element-412">
                <span data-id="element-413">🍽️</span> 15 Recetas Médicas
              </div>
              <div className="flex items-center gap-2 bg-cream px-4 py-2 rounded-full" data-id="element-414">
                <span data-id="element-415">🎯</span> Sistema Paso a Paso
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}